import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { has, isNull } from 'lodash-es';

import { CoreConfig } from '../../core.module';
import { KeyRefreshEnum } from '../../enums/key-refresh';
import {
  ShouldConvertStatusCodeErrors,
  ShouldConvertWalkingFarmCountErrors,
  ShouldIgnoreLoader,
  ShouldRefreshKey
} from '../../typings/property-force-api';

@Injectable({
  providedIn: 'root'
})
export class PropertyForceApiService {
  private coreConfig = inject<CoreConfig>(CoreConfig);
  private httpClient = inject(HttpClient);

  getData<T>(
    endPoint: string,
    parameters?: {
      [key: string]: string | number | boolean | null;
    },
    contextOptions?: {
      ignoreLoader?: boolean;
      keyRefreshType?: KeyRefreshEnum;
      providerId?: string;
      shouldConvertStatusCodeErrors?: boolean;
      shouldConvertWalkingFarmCountErrors?: boolean;
    }
  ) {
    const headerOptions: {
      [key: string]: string | boolean;
    } = {};
    const context = new HttpContext();

    if (has(contextOptions, 'ignoreLoader')) {
      context.set(ShouldIgnoreLoader, !!contextOptions.ignoreLoader);
    } else {
      context.set(ShouldIgnoreLoader, false);
    }

    if (has(contextOptions, 'keyRefreshType')) {
      context.set(ShouldRefreshKey, contextOptions.keyRefreshType);
    } else {
      context.set(ShouldRefreshKey, KeyRefreshEnum.None);
    }

    if (has(contextOptions, 'shouldConvertStatusCodeErrors')) {
      context.set(ShouldConvertStatusCodeErrors, true);
    } else {
      context.set(ShouldConvertStatusCodeErrors, false);
    }

    if (has(contextOptions, 'shouldConvertWalkingFarmCountErrors')) {
      context.set(ShouldConvertWalkingFarmCountErrors, true);
    } else {
      context.set(ShouldConvertWalkingFarmCountErrors, false);
    }

    const headers = new HttpHeaders(headerOptions as { [name: string]: string | string[] });

    let params = new HttpParams();
    for (const key in parameters) {
      if (has(parameters, key) && !isNull(parameters[key])) {
        params = params.append(key, parameters[key]);
      }
    }

    return this.httpClient.get<T>(this.coreConfig.propertyForce.baseUrl + endPoint, {
      context,
      headers,
      params
    });
  }
}
